import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import UpcomingVirtualVisitCard from './UpcomingVirtualVisitCard';
import UpcomingBillsCard from './UpcomingBillsCard';
import UpcomingConsentsCard from './UpcomingConsentsCard';
import { useQuery } from '@apollo/client';
import {
  FETCH_ALL_VIRTUAL_VISIT_QUERY,
  FETCH_UPCOMING_BILLS_QUERY,
  FETCH_UPCOMING_CONSENTS_QUERY,
} from '../../services/UpcomingCardsService/UpcomingCardService';
import {
  formatDateInMMDDYYYYWithComma,
  formatTimeInHHMMWithComma,
} from '../../shared/helper';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { DEFAULT_NULL_REPLACEMENT } from '../../shared/constants';
import avataricon from '../../assests/avataricon.svg';
import { UPCOMING_CARD } from '../../shared/Strings';

function CardComponent() {
  const [consentsFlag, setConsentsFlag] = useState(false);
  const [virtualVisitFlag, setVirtualVisitFlag] = useState(false);
  const [billsFlag, setBillsFlag] = useState(false);
  const [virtualVisitDataForCard, setVirtualVisitDataForCard] = useState();
  const [consentsDataForCard, setConsentsDataForCard] = useState();
  const [billsDataForCard, setBillsDataForCard] = useState();

  const allConsentsData = useQuery(FETCH_UPCOMING_CONSENTS_QUERY, {
    variables: { sourceUrl: '' },
  });

  const allVirtualVisitData = useQuery(FETCH_ALL_VIRTUAL_VISIT_QUERY, {
    variables: { sourceUrl: '' },
  });
  const allBillData = useQuery(FETCH_UPCOMING_BILLS_QUERY, {
    variables: { sourceUrl: '' },
  });
  const loading =
    allConsentsData.loading ||
    allVirtualVisitData.loading ||
    allBillData.loading;

  useEffect(() => {
    if (
      allConsentsData?.data?.fetchUpcommingConsents
        ?.upComingConsentResourceList &&
      JSON.parse(
        allConsentsData?.data?.fetchUpcommingConsents
          ?.upComingConsentResourceList
      )[0] != null
    ) {
      const parsedConsentData = JSON.parse(
        allConsentsData?.data?.fetchUpcommingConsents
          ?.upComingConsentResourceList
      )[0];

      const consentsData = {
        title: UPCOMING_CARD.CONSENTS,

        greenLabel: parsedConsentData?.scope?.text || DEFAULT_NULL_REPLACEMENT,
        orangeLabel:
          'Expires On ' +
            formatDateInMMDDYYYYWithComma(
              parsedConsentData?.provision?.dataPeriod?.end
            ) || DEFAULT_NULL_REPLACEMENT,

        secondaryBtnTitle: UPCOMING_CARD.BUTTON_TEXT.VIEW_DETAILS,
        avatarName: parsedConsentData?.provision?.actor
          ? parsedConsentData?.provision?.actor?.[0]?.reference?.display
          : DEFAULT_NULL_REPLACEMENT,
        avatarLink: avataricon,
      };
      setConsentsDataForCard(consentsData);
      setConsentsFlag(true);
    }
  }, [allConsentsData.data]);
  useEffect(() => {
    if (allBillData.data?.billSummary?.totalDue) {
      const billsData = {
        title: UPCOMING_CARD.BILLS,

        amount:
          '$' + allBillData.data.billSummary.totalDue ||
          DEFAULT_NULL_REPLACEMENT,
        orangeLabel: UPCOMING_CARD.DUE_NEXT_WEEK,
        primaryBtnTitle: UPCOMING_CARD.PAY_BILL,
        secondaryBtnTitle: UPCOMING_CARD.VIEW_DETAILS,
      };

      setBillsDataForCard(billsData);
      setBillsFlag(true);
    }
  }, [allBillData.data]);

  useEffect(() => {
    if (allVirtualVisitData?.data?.fetchUpCommingAppointments) {
      const parsedData = JSON.parse(
        allVirtualVisitData?.data?.fetchUpCommingAppointments
          ?.appointmentResource
      );
      const virtualVisitData = {
        id: parsedData.id,
        title: UPCOMING_CARD.VIRTUAL_VISIT_TITLE,
        primaryBtnTitle: UPCOMING_CARD.BUTTON_TEXT.JOIN_VISIT,
        secondaryBtnTitle: UPCOMING_CARD.BUTTON_TEXT.VIEW_DETAILS,
        date:
          formatDateInMMDDYYYYWithComma(parsedData?.start) ||
          DEFAULT_NULL_REPLACEMENT,
        time:
          formatTimeInHHMMWithComma(parsedData?.start) ||
          DEFAULT_NULL_REPLACEMENT,
        avatarName:
          parsedData?.participant?.[0].actor.display || DEFAULT_NULL_REPLACEMENT,
        avatarLink: avataricon,
      };
      setVirtualVisitDataForCard(virtualVisitData);
      setVirtualVisitFlag(true);
    }
  }, [allVirtualVisitData.data]);

  return (
    <div>
      {consentsFlag || billsFlag || virtualVisitFlag ? (
        <div sx={{ mt: 2 }}>
          <Box sx={{ width: '100%' ,mt:'20px'}}>
            <Typography variant="title">{UPCOMING_CARD.UPCOMING}</Typography>
            <Grid container sx={{ mt: 3 }}>
              {virtualVisitFlag ? (
                <Grid item sx={{ mr: 2, mb: 2}}>
                  <UpcomingVirtualVisitCard
                    cardData={virtualVisitDataForCard}
                  />
                </Grid>
              ) : null}

              {billsFlag ? (
                <Grid item sx={{ mr: 2, mb: 2}}>
                  <UpcomingBillsCard cardData={billsDataForCard} />
                </Grid>
              ) : null}

              {consentsFlag ? (
                <Grid item sx={{ mr: 2, mb: 2 }}>
                  <UpcomingConsentsCard cardData={consentsDataForCard} />
                </Grid>
              ) : null}
            </Grid>
          </Box>
          <SimpleBackdrop open={loading} />
        </div>
      ) : null}
    </div>
  );
}

export default CardComponent;
